export default {
  name: "Language",
  en: "English",
  cn: "简体中文",
  tw: "កម្ពុជា",
  vi: "Tiếng Việt",
  th: "ไทย",
  id: "Indonesia",
  my: "Myanmar",
  jp: "日本語",
  kr: "한국어"
};
